import React, {memo} from "react";
//local
import {Info} from "components/Info";
import cn from "classnames";

export const TitleIcon = memo(
  ({
    title,
    icon,
    prefixTooltipContent,
    suffixTooltipContent,
    tooltip,
    medium,
    small,
    uppercase = true,
    addClass,
  }) => {
    return (
      <div
        className={cn("title-icon_wrapper", {
          [addClass]: !!addClass,
          __medium: !!medium,
          __small: !!small,
          __uppercase: !!uppercase,
        })}
      >
        {icon}
        <span>{title}</span>
        {prefixTooltipContent}
        {tooltip && <Info tooltip={tooltip} centerText addClass="ml-2 mr-2" />}
        {suffixTooltipContent}
      </div>
    );
  }
);
